import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Spinner } from 'reactstrap';
import { useParams, useNavigate } from "react-router-dom";

import Breadcrumbs from "components/Common/Breadcrumb";
import Overview from './Overview';
import DetailsSection from './DetailsSection';
import DocumentPreviewModal from "./DocumentPreviewModal";
import RejectPreRegistrationModal from "./RejectPreRegistrationModal";

import {
    getPreRegistrationByUuid as onGetPreRegistrationByUuid,
    approvePreRegistration as onApprovePreRegistration,
    //rejectPreRegistration as onRejectPreRegistration,
    addNewPreRegistrationRejection as onAddNewPreRegistrationRejection,
} from "../../../../store/actions";

import { RESET_PRE_REGISTRATION_ACTION } from "store/pre-registrations/actionTypes";
import { ToastContainer } from "react-toastify";

const PreRegistrationDetails = () => {
    document.title = "Détails préinscription | Cinzan Edu";

    const { uuid } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { preRegistration, loading, actionSuccess, approveLoading } = useSelector(
        state => state.preRegistrationReducer
    );

    const { loading: rejectLoading, actionSuccess: rejectSuccess } = useSelector(
        state => state.preRegistrationRejectionReducer
    );

    /** Preview documents */
    const [file, setFile] = useState(null);
    const [openPreviewModal, setOpenPreviewModal] = useState(false);

    /** Rejet */
    const [showRejectModal, setShowRejectModal] = useState(false);

    /* =======================
       Chargement
       ======================= */
    useEffect(() => {
        if (uuid) {
            dispatch(onGetPreRegistrationByUuid(uuid));
        }
    }, [uuid, dispatch]);

    /* =======================
       Après succès action
       ======================= */
    useEffect(() => {
        if (actionSuccess) {
            navigate("/pre-registrations");
            dispatch({ type: RESET_PRE_REGISTRATION_ACTION });
        }
    }, [actionSuccess, navigate, dispatch]);

    useEffect(() => {
    if (rejectSuccess) {
        navigate("/pre-registrations"); // redirection après succès
        dispatch({ type: "RESET_PRE_REGISTRATION_REJECTION_ACTION" });
    }
    }, [rejectSuccess, navigate, dispatch]);

    /* =======================
       Handlers
       ======================= */
    const openPreview = (file) => {
        setFile(file);
        setOpenPreviewModal(true);
    };

    const handleApprove = () => {
        //dispatch(onApprovePreRegistration({uuid: preRegistration.uuid}));
        dispatch(onApprovePreRegistration(preRegistration));
    };

    const handleRejectSubmit = (reason) => {

        const payload = {
            pre_registration_id: preRegistration.id,
            reason: reason
        }

        //console.log("PAYLOAD ON REJECT", payload);
        //dispatch(onRejectPreRegistration(payload));
        dispatch(onAddNewPreRegistrationRejection(payload));
        setShowRejectModal(false);
    };

    /* =======================
       Loading
       ======================= */
    if (loading || !preRegistration) {
        return (
            <Container fluid className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
                <Spinner color="primary" />
            </Container>
        );
    }

    /* =======================
       Render
       ======================= */
    return (
        <>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Préinscription" breadcrumbItem="Détails" />

                    <Row>
                        <DetailsSection preRegistration={preRegistration} />

                        <Overview
                            preRegistration={preRegistration}
                            onPreview={openPreview}
                            onApprove={handleApprove}
                            onReject={() => setShowRejectModal(true)}
                            approveLoading={approveLoading}
                            rejectLoading={rejectLoading} 
                        />
                    </Row>
                </Container>
            </div>

            {/* Preview document */}
            <DocumentPreviewModal
                isOpen={openPreviewModal}
                toggle={() => setOpenPreviewModal(false)}
                file={file}
            />

            {/* Modal rejet */}
            <RejectPreRegistrationModal
                isOpen={showRejectModal}
                toggle={() => setShowRejectModal(false)}
                onSubmit={handleRejectSubmit}
            />

            <ToastContainer />
        </>
    );
};

export default PreRegistrationDetails;
